<template>
  <div>
    <div class="row">
      <h1 class="col-8 primary-text">{{ title }}</h1>
      <div class="col-4 text-left ">
        <v-btn text :to="{path:'ArticlesList',query:{isOnline:isOnline}}" small>
          <span class="primary-text ml-2 pointer">MORE</span> <i
            class="fa-solid fa-arrow-left fa-lg pointer"></i>
        </v-btn>
      </div>
    </div>
    <div v-if="dataLoading" class=" align-items-center ">
      <div class="row" v-for="i in 3" :key="i">
        <div class="col-4 text-center">
          <v-skeleton-loader
              class="mx-auto"
              type="image"
          ></v-skeleton-loader>
        </div>
        <div class="col-8 text-center pr-0">
          <v-skeleton-loader

              type="list-item-three-line"
          ></v-skeleton-loader>
        </div>
      </div>

    </div>
    <div v-else-if="items.length > 0 && items !== undefined" class="row">


        <VueSlickCarousel v-bind="settings" :arrows="true" class="col-12">
          <router-link :to="{path:'ContentsDetail',query:{ExtraExtensionID:item.ExtraExtensionID}}" v-for="(item,i) in items" :key="i" class="py-0 d-block">
            <div class="row align-items-center" dir="rtl">
              <div class="col-auto py-1">
                <v-img :src="$replaceHttps(item.FileUrl)" class="rounded-lg" height="120" width="120">

                </v-img>
              </div>
              <div class="col py-1 ">
                {{ item.Name }}
              </div>
            </div>
          </router-link>
        </VueSlickCarousel>


    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: "Articles",
  props: ['items', 'title', 'dataLoading','isOnline'],
  components:{
    VueSlickCarousel
  },
  data:()=>({
    settings: {
      "infinite": true,
      "speed": 500,
      "rows": 3,
      "dots": false,
      "arrows": true,
      "rtl": false,
      "slidesToShow":1,
      "initialSlide": 0,
      // "responsive": [
      //   {
      //     "breakpoint": 1100,
      //     "settings": {
      //       "slidesToShow": 2,
      //     }
      //   },
      //   {
      //     "breakpoint": 600,
      //     "settings": {
      //       "slidesToShow": 1,
      //     }
      //   },
      //
      // ]
    },
  }),

}
</script>

<style scoped>

</style>
